import { render, staticRenderFns } from "./write.vue?vue&type=template&id=1d8a8dce&scoped=true&"
import script from "./write.vue?vue&type=script&lang=js&"
export * from "./write.vue?vue&type=script&lang=js&"
import style0 from "./write.vue?vue&type=style&index=0&id=1d8a8dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a8dce",
  null
  
)

export default component.exports